import { createContext, useContext } from 'react'

/**
 * The global creation-date range that scopes every admin view. Dates are held in
 * the API's date-only `YYYYMMDD` convention so they pass straight through to the
 * backend filter parser; views consume this so their numbers line up.
 *
 * `includeInternal` is the opt-in toggle (default off): when off, internal users and
 * everything cascading from them are excluded so the numbers reflect real market
 * signal (ADR 0002). It scopes every view, so it lives here alongside the date range.
 */
export interface AdminFilterValue {
	from: string
	to: string
	setRange: (from: string, to: string) => void
	includeInternal: boolean
	setIncludeInternal: (includeInternal: boolean) => void
}

export { ADMIN_DEFAULT_WINDOW_DAYS } from './dateRange'

export const AdminFilterContext = createContext<AdminFilterValue | null>(null)

export const useAdminFilter = (): AdminFilterValue => {
	const ctx = useContext(AdminFilterContext)
	if (!ctx) {
		throw new Error('useAdminFilter must be used within an AdminFilterProvider')
	}
	return ctx
}
